import { z } from 'zod'

const LocalizedStringSchema = z.object({
  en: z.string(),
  fr: z.string().optional(),
  ar: z.string().optional()
})
export type LocalizedString = z.infer<typeof LocalizedStringSchema>

const StatusSchema = z.object({
  key: z.string(),
  title: LocalizedStringSchema
})

const PhoneSchema = z.object({
  code: z.string(),
  number: z.string()
})

const CoordsSchema = z.object({
  lng: z.number(),
  lat: z.number()
})

export { CoordsSchema, LocalizedStringSchema, PhoneSchema, StatusSchema }
